import { render, staticRenderFns } from "./departmentUser.vue?vue&type=template&id=4ffee9c0&"
import script from "./departmentUser.vue?vue&type=script&lang=js&"
export * from "./departmentUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports